import type { IData } from '../model/IData'
import { expectDefined } from './expectDefined'
import { getParentCouple } from './getParentCouple'

export function getSiblings(data: IData, personId: string) {
	const parentCouple = getParentCouple(data, personId)
	if (!parentCouple) return undefined
	if ((parentCouple.childIds?.length ?? 0) <= 1) {
		// In the case of a single child, there is no need to show the person.
		return undefined
	}
	return (
		parentCouple.childIds
			// // Filter out the person.
			// ?.filter((id) => id !== personId)
			?.map((id) => expectDefined(data.personsById[id]))
	)
}
